"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _createStyles = _interopRequireDefault(require("../utils/createStyles"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var _default = theme => _objectSpread(_objectSpread({
  wrap: {
    display: 'flex'
  },
  icon: {
    '& .fill': {
      fill: theme.icon.color
    },
    '& .stroke': {
      stroke: theme.icon.color
    },
    '&.error': {
      '& .fill': {
        fill: theme.errorColor
      },
      '& .stroke': {
        stroke: theme.errorColor
      }
    },
    '&.disabled': {
      opacity: theme.disabledOpacity
    },
    '&.hidden': {
      display: 'none'
    }
  }
}, (0, _createStyles.default)('fill', theme.palette, ({
  styleObject
}) => ({
  '& .fill': styleObject
}))), {}, {
  micro: {
    width: theme.icon.micro,
    height: theme.icon.micro
  },
  small: {
    width: theme.icon.small,
    height: theme.icon.small
  },
  medium: {
    width: theme.icon.medium,
    height: theme.icon.medium
  },
  large: {
    width: theme.icon.large,
    height: theme.icon.large
  },
  xlarge: {
    width: theme.icon.xlarge,
    height: theme.icon.xlarge
  },
  xxlarge: {
    width: theme.icon.xxlarge,
    height: theme.icon.xxlarge
  }
});

exports.default = _default;